import { GlIcon, GlLink, GlSprintf } from '@gitlab/ui';
import { s__ } from '~/locale';
export default {
    name: 'MrWidgetSecurityPolicyPipelineNote',
    components: {
        GlIcon,
        GlLink,
        GlSprintf
    },
    props: {
        mr: {
            type: Object,
            required: true
        }
    },
    i18n: {
        message: s__('mrWidget|Merge request pipeline has passed, but a security policy requires all pipelines to succeed. Another pipeline for this commit has failed. %{linkStart}View policies%{linkEnd}')
    }
};
